import { Component, Input, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Compiler, ViewChild } from '@angular/core';
import * as $ from 'jquery';

import { ProductService } from '../../services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var document: any;
declare var Swiper: any;
declare var window: any;
@Component({
  selector: 'app-view-cms-content',
  templateUrl: './view-cms-content.component.html',
  styleUrls: ['./view-cms-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewCmsContentComponent implements AfterViewInit {
  @Input() cmsContentUrl?: string;
  @Input() cmsContentId?: string;
  @ViewChild('htmlContainer') container;
  trustedHTML: any;
  constructor(
    private productService: ProductService,
    private UTS: UtilitiesService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }
  ngAfterViewInit(): void {
    if (this.cmsContentUrl) {

      setTimeout(() => {

        this.productService
          .getCMSContent(this.cmsContentUrl, 'GET')
          .subscribe((res: any) => {
            this.trustedHTML = this.sanitizer.bypassSecurityTrustHtml(res.htmlSrc.toString());

            setTimeout(() => { //wait for DOM rendering
              let scripts = this.container.nativeElement.getElementsByTagName('script');
              for (let script of scripts) {
                if(script && script.text){
                  eval(script.text)
                }
              }
            })
            this.cdr.detectChanges();
            const currentLang = $('#mainIndex').attr('lang');
            $('#language').on('click', (e: any) => {
              e.preventDefault();
              if (window.location.href.indexOf('/b2c/') > 0) {
                if (currentLang && currentLang.toString().toLowerCase() == 'en')
                  window.location.href = this.updateQueryStringParam('AR');
                else if (
                  currentLang &&
                  currentLang.toString().toLowerCase() == 'ar'
                )
                  window.location.href = this.updateQueryStringParam('EN');
              }
              this.cdr.detectChanges();
            });
          }, (e) => {

          });
      }, 1500);
    }
  }

  private updateQueryStringParam(value: string): string {
    const key = 'locale';
    var keyRegex = new RegExp(`([\?&])${key}[^&]*`);
    const baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const urlQueryString = document.location.search;
    const newParam = `${key}=${value}`;
    if (urlQueryString) {
      if (urlQueryString.match(keyRegex) !== null)
        return `${baseUrl}${urlQueryString.replace(keyRegex, '$1' + newParam)}`;
      else return `${urlQueryString}&${newParam}`;
    }
    return `${baseUrl}${newParam}`;
  }

 



}